import Modal, {ModalProps} from 'react-bootstrap/Modal';
import React from "react";
import {useTranslation} from "react-i18next";

const ZeroSubscriptions = ({...props}: ModalProps)  => {
    const { t } = useTranslation();
    return (

        <Modal
            {...props}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <h4><b>{t('captions.warning')}</b></h4> <br />
                Non hai inserito ancora nessuna richiesta.<br />
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn_1 green" onClick={props.onHide}>{t('captions.close')}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ZeroSubscriptions;
